import base from './baseApi';

const { urls, methods, execute } = base();

export const getGlobalConfigByType = (type: string) => {
   const method = methods.GET;
   const url = `${urls.globalConfig}/${type}`;

   return execute(method, url, { authorization: true });
};

export const uploadGlobalVideo = (payload: {file: File | Blob, type: string }) => {
  return execute(methods.POST,`${urls.globalConfig}/${payload.type}/landing-video`, { authorization: true }, payload, true);
}